/**
 * 转换keyWords数据结构, [[关键字1], [关键字2],[关键字3]]  <-->  '关键字1, 关键字2, 关键字3'
 * @param data
 * @param strToArray
 * @returns
 */
export function handleKeyWords(data: any, strToArray?: any) {
  if (!data) return null;

  if (strToArray) {
    return modifySymbolFormat(data)
      .split(/[，；、|\n]/)
      .filter((item: any) => item.trim() !== '')    // 去除空白内容的关键词
      .map((item: any) => [item.trim()]);
  }
  return data.flat().join('，');
}

/**
 * 把keyWords的[strign][]数据格式转换为下拉框选项格式
 * @param data
 * @returns
 */
export function handleKeyWordsToOptions(data: any) {
  if (!data?.[0]) return [];
  return data.map((item: any) => ({
    text: item[0],
    value: item[0],
  }));
}

/**
 * 转换tags数据结构   [{"name":"标签1","value":[["关键字1.1"],["关键字1.2"]]},{"name":"标签2","value":[["关键字2.1"],["关键字2.2"]]}]  <-->  '标签1：关键字1.1，关键字1.2；标签2：关键字2.1，关键字2.2'
 * @param data
 * @param strToArray
 * @returns
 */
export function handleTags(data: any, strToArray?: any) {
  if (!data) return null;

  if (strToArray) {
    return modifySymbolFormat(data)
      .split('；')
      .map((tagGroup: any) => tagGroup.trim())
      .filter((tagGroup: any) => tagGroup)
      .map((tagGroup: any) => {
        const parts = tagGroup.split('：');

        if (parts.length < 2) return null;

        const tagName = parts[0].trim();
        const keywordsStr = parts.slice(1).join('：').trim();

        if (!tagName || !keywordsStr) return null;

        const keywords = keywordsStr
          .split('，')
          .map((keyword: any) => keyword.trim())
          .filter((keyword: any) => keyword)
          .map((keyword: any) => [keyword]);

        return {
          name: tagName,
          value: keywords,
        };
      })
      .filter((item: any) => item !== null);
  }
  return data
    .map((item: any) => {
      const keywords = item.value
        .map((subArray: any) => subArray[0]) // 提取每个子数组的第一个元素
        .join('，');
      return `${item.name}：${keywords}`;
    })
    .join('；');
}

/**
 * 判断标签input的内容是否符合格式
 */
export function isValidTags(data: string) {
  if (!data.trim()) return true;
  const str = data
    .replace(/：/g, ':') // 中文冒号转英文冒号
    .replace(/；/g, ';') // 中文分号转英文分号
    .replace(/，/g, ',') // 中文逗号转英文逗号
    .trim();

  // 按分号分割标签组
  const tagGroups = str.split(';');

  for (const group of tagGroups) {
    const trimmedGroup = group.trim();
    if (trimmedGroup === '') return false;

    // 检查是否包含冒号分隔符
    const colonIndex = trimmedGroup.indexOf(':');
    if (colonIndex === -1) return false;

    // 提取标签和关键字部分
    const tag = trimmedGroup.substring(0, colonIndex).trim();
    const keywordsStr = trimmedGroup.substring(colonIndex + 1).trim();

    // 验证标签非空
    if (tag === '') return false;

    // 验证关键字部分
    const keywords = keywordsStr.split(',');
    if (keywords.length === 0) return false;

    for (const keyword of keywords) {
      const trimmedKeyword = keyword.trim();
      if (trimmedKeyword === '') return false;
    }
  }

  return true;
}

/**
 * 把字符串的冒号(:)和逗号(,)和分号(;)格式统一转换为中文符号
 */
function modifySymbolFormat(value: string) {
  return value
    .replace(/:/g, '：') // 中文冒号转英文冒号
    .replace(/;/g, '；') // 中文分号转英文分号
    .replace(/,/g, '，') // 中文逗号转英文逗号
    .trim();
}
